/**
 * Cliente API de personas.
 *
 * Sprint 12 S12-05: listPersonas con roles vigentes + lote actual.
 * Sprint 13 S13-12: crearPersona + actualizarPersona (mantenedor sa).
 */
import { apiFetch } from './client';
import type {
  ListPersonasFiltros,
  PersonaConRoles,
  PersonaCreate,
  PersonaRead,
  PersonaUpdate,
} from './types';

export function listPersonas(
  filtros: ListPersonasFiltros = {},
): Promise<PersonaConRoles[]> {
  const params = new URLSearchParams();
  if (filtros.search) params.set('search', filtros.search);
  if (filtros.con_rol) params.set('con_rol', filtros.con_rol);
  if (filtros.activo !== undefined) params.set('activo', String(filtros.activo));
  const qs = params.toString();
  return apiFetch<PersonaConRoles[]>(`/personas/${qs ? `?${qs}` : ''}`);
}

export function crearPersona(data: PersonaCreate): Promise<PersonaRead> {
  return apiFetch<PersonaRead>('/personas/', {
    method: 'POST',
    body: JSON.stringify(data),
  });
}

export function actualizarPersona(
  personaId: string,
  data: PersonaUpdate,
): Promise<PersonaRead> {
  return apiFetch<PersonaRead>(`/personas/${personaId}`, {
    method: 'PATCH',
    body: JSON.stringify(data),
  });
}

// Sprint 13 S13-16: import CSV.
export interface ImportCsvResultadoPersonas {
  total_filas: number;
  creados: number;
  errores: { fila: number; error: string }[];
}

export function importPersonasCsv(
  archivo: File,
): Promise<ImportCsvResultadoPersonas> {
  const form = new FormData();
  form.append('archivo', archivo);
  return apiFetch<ImportCsvResultadoPersonas>('/personas/import-csv', {
    method: 'POST',
    body: form,
  });
}

// Sprint 13 S13-18: DELETE con guard de relaciones.
export function eliminarPersona(personaId: string): Promise<void> {
  return apiFetch<void>(`/personas/${personaId}`, { method: 'DELETE' });
}
